import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CountryApiData } from '../models/Country.model';
import { CountryRepository } from '../repositories/country.repository';

export type GetCountriesUseCaseInput = {
    language: string;
};

export class GetCountriesUseCase
    implements UseCase<GetCountriesUseCaseInput, CountryApiData>
{
    constructor(private readonly repository: CountryRepository) {}

    execute({
        language,
    }: GetCountriesUseCaseInput): Observable<CountryApiData> {
        return this.repository.getCountries(language);
    }
}
